<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    xSmall: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    noSpacing: {
      type: Boolean,
      default: false,
    },
    externalLabel: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Tags',
    },
    placeholder: {
      type: String,
      default: 'Insira uma nova tag',
    },
    buttonText: {
      type: String,
      default: 'Incluir tag',
    },
    defaultMessage: {
      type: String,
      default: 'Nenhuma tag inserida.',
    },
    textType: {
      type: String,
      default: 'TAGS:',
    },
  },
  data() {
    return {
      tag: '',
    }
  },
  methods: {
    addTag() {
      if (!this.tag) {
        return
      }
      const aux = [...new Set([...(this.value || []), this.tag])]
      this.$emit('input', aux)

      this.tag = ''
    },
    removeTag(t) {
      const aux = (this.value || []).filter((item) => {
        return item !== t
      })
      this.$emit('input', aux)
    },
  },
}
</script>

<template>
  <div class="tags-field">
    <div v-if="externalLabel" class="az-text-label"> {{ label }}</div>

    <v-text-field
      v-if="!readonly"
      v-model="tag"
      :label="externalLabel ? '' : label"
      :placeholder="placeholder"
      :outlined="outlined"
      hide-details
      @keypress.enter="addTag"
    >
      <template v-slot:append>
        <v-btn small color="primary" @click="addTag"> {{ buttonText }} </v-btn>
      </template>
    </v-text-field>
    <div class="d-flex align-items-center mt-2" style="flex-wrap: wrap">
      <p v-if="!readonly" class="subtitle mb-0 mr-2"> {{ textType }} </p>
      <template>
        <v-chip
          v-for="(t, i) in value"
          :key="i"
          :class="{ 'mr-1 mt-1': !noSpacing }"
          :close="!readonly"
          :small="small"
          :x-small="xSmall"
          @click:close="removeTag(t)"
        >
          {{ t }}
        </v-chip>
      </template>
      <p v-if="!(value || []).length && !readonly" class="mb-0">
        <small class="text-secondary"> {{ defaultMessage }} </small>
      </p>
    </div>
  </div>
</template>

<style lang="sass">
.tags-field
  .v-text-field--outlined
    .v-input__append-inner
      margin-top: 0 !important
      align-self: center
</style>
